/** @internal */
export const symbol = /*#__PURE__*/Symbol.for("@effect/schema/Serializable/symbol");
/** @internal */
export const symbolResult = /*#__PURE__*/Symbol.for("@effect/schema/Serializable/symbolResult");
//# sourceMappingURL=serializable.js.map